import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminDocumentTypes } from '@/api/(admin)/document-types';
import type { AdminDocumentType } from '@/api/(admin)/document-types/types';
import type { DocumentTypesQueryInput } from '../-types';
import {
  buildDocumentTypesQs,
  toDocumentTypesParams,
} from '../-utils/listParams';

/** Prefix for every document-types cache entry — what a write invalidates. */
export const adminDocumentTypesQueryKey = ['admin', 'document-types'] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export function adminDocumentTypesQueryOptions(input: DocumentTypesQueryInput) {
  const params = toDocumentTypesParams(input);
  return queryOptions({
    queryKey: [...adminDocumentTypesQueryKey, 'list', params] as const,
    queryFn: () => fetchAdminDocumentTypes(buildDocumentTypesQs(params)),
  });
}

export function useAdminDocumentTypes(input: DocumentTypesQueryInput) {
  const query = useQuery(adminDocumentTypesQueryOptions(input));
  const rows: AdminDocumentType[] = query.data?.data ?? [];
  return { ...query, rows, totalCount: query.data?.meta?.totalCount ?? 0 };
}
